import React from 'react';
import { Wrapper } from './LocationPageSectionFooter.style';

const LocationPageSectionFooter: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default LocationPageSectionFooter;
